import { useState } from 'react'

import { Tabs, Button, Icon } from '@loadsmart/miranda-react'

import { type ShipperDetail } from '../../../domain/shippers'
import { UploadDocumentDialog } from './UploadDocumentDialog'

export type ShipperDocumentsTabProps = {
  details: ShipperDetail
}

export function ShipperDocumentsTab({ details }: ShipperDocumentsTabProps) {
  const [dialogOpen, setDialogOpen] = useState(false)
  function openDialog() {
    setDialogOpen(true)
  }
  function closeDialog() {
    setDialogOpen(false)
  }
  return (
    <>
      <Tabs.Tab name="documents">Documents</Tabs.Tab>
      <Tabs.Panel forTab="documents">
        <Button variant="secondary" type="button" onClick={openDialog}>
          <Icon name="upload" color="color-primary-100" />
          Upload documents
        </Button>
      </Tabs.Panel>
      <UploadDocumentDialog open={dialogOpen} onClose={closeDialog} shipperUUID={details.uuid} />
    </>
  )
}
